import React, { useEffect } from 'react';
import Head from 'next/head';
import getConfig from 'next/config';
import { hotjar } from 'react-hotjar';
import { isProduction } from './Utils';

interface MetaProps {
  title?: string;
}

const { publicRuntimeConfig } = getConfig();

const Meta: React.FC<MetaProps> = ({ title = 'Church Online Platform' }) => {
  useEffect(() => {
    if (process.browser && isProduction()) {
      hotjar.initialize(getConfig().publicRuntimeConfig.HOTJAR_ID, 6);
    }
  }, []);

  return (
    <Head>
      <title>{title}</title>
      <meta
        content='width=device-width, maximum-scale=1.0, initial-scale=1.0, user-scalable=no'
        name='viewport'
      />
      <meta charSet='utf-8' />
      <link href={`/admin/static/favicon.ico`} rel='shortcut icon' />
      <link
        as='font'
        crossOrigin='anonymous'
        href='https://static-assets.life.church/fonts/proximanova/proximanova-black-webfont.woff2'
        rel='preload'
      />
      <link
        as='font'
        crossOrigin='anonymous'
        href='https://static-assets.life.church/fonts/proximanova/proximanova-bold-webfont.woff2'
        rel='preload'
      />
      <link
        as='font'
        crossOrigin='anonymous'
        href='https://static-assets.life.church/fonts/proximanova/proximanova-regular-webfont.woff2'
        rel='preload'
      />
      <link
        as='font'
        crossOrigin='anonymous'
        href='https://static-assets.life.church/fonts/proximanova/proximanova-semibold-webfont.woff2'
        rel='preload'
      />
      <link href={`/admin/static/nprogress.css`} rel='stylesheet' type='text/css' />
      <script async src='https://fast.wistia.com/embed/medias/lncrwcxqpx.jsonp' />
      <script async src='https://fast.wistia.com/assets/external/E-v1.js' />
      {process.browser && document.body && (
        <script src='https://2qrjt0yl82kw.statuspage.io/embed/script.js' />
      )}
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${publicRuntimeConfig.GA_TRACKING_ID}`}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${publicRuntimeConfig.GA_TRACKING_ID}');
          `,
        }}
      />
      <script defer src='https://app.getbeamer.com/js/beamer-embed.js' type='text/javascript' />
    </Head>
  );
};

export default Meta;
